<div mat-dialog-content class="root">
  <app-test-results />
</div>
